export const overLayerControlsHideThreshold = 100;

export const Shapes = new Set(['rect', 'ellipse', 'triangle', 'pencil']);

export const FAKE_IMAGE_URL = 'copy/sd-images/2daf83d29cec1eacbaa1545a110179a180612c93bff7d9f1f150e62001a87f5e.png';

export const XINGLIU_MODEL_BASE_TYPE = 'FLUX.1'; // 星流基础大模型
